import { createRoot } from "react-dom/client";
import App from "./App";
import "./pwa";

createRoot(document.getElementById("root")!).render(<App />);
